import { EventBusMessage } from '../util/event-bus-util'

export enum MetaPixelMethod {
  TRACK = 'track',
  TRACK_CUSTOM = 'trackCustom',
}

export enum MetaPixelEvent {
  LEAD = 'Lead',
  COMPLETE_REGISTRATION = 'CompleteRegistration',
}

export type MetaPixelMessage = {
  methodName: MetaPixelMethod
  eventName?: MetaPixelEvent
  properties?: { [key: string]: string | number }
}

export const metaPixelService = {
  _push: (params: { metaPixelMessage: MetaPixelMessage }): void => {
    const { metaPixelMessage } = params
    const { methodName, eventName, properties } = metaPixelMessage
    const payload = [methodName, eventName, properties].filter(Boolean)
    window.fbq(...payload)
  },

  sendUserCreated: (_: { message: EventBusMessage }): void => {
    const metaPixelMessage = {
      methodName: MetaPixelMethod.TRACK,
      eventName: MetaPixelEvent.LEAD,
    }
    metaPixelService._push({ metaPixelMessage })
  },

  sendRegistrationCompleted: (_: { message: EventBusMessage }): void => {
    const metaPixelMessage = {
      methodName: MetaPixelMethod.TRACK,
      eventName: MetaPixelEvent.COMPLETE_REGISTRATION,
    }
    metaPixelService._push({ metaPixelMessage })
  },
}
